import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Typography,
  Skeleton,
  Alert,
} from "antd";
import { useState, useEffect } from "react";
import {
  toGetEmplacementList,
  toDeleteEmplacement,
  toAddOrUpdateEmplacement,
  toGetListStocksOfEmplacement,
  toUpdateEntityOfEmplacements,
} from "./Api";
import { toGetEntityList } from "../Compte/Api";
import { PlusOutlined } from "@ant-design/icons";
import cookie from "react-cookies";

import { BiPencil, BiTrash } from "react-icons/bi";
import { errorMsg, successMsg, toConvertDate } from "../../Utils/Utils";
import "../../Styles/TwoTables.scss";

import Search from "../../Utils/Search";
import DataTable from "react-data-table-component";
import SearchInput from "./SearchInput";

const Emplacement = (props) => {
  const [loading, setLoading] = useState(true);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [emplacements, setEmplacements] = useState([]);
  const [emplacementsAll, setEmplacementsAll] = useState([]);
  const [title, setTitle] = useState("");
  const [id, setId] = useState(-1);
  const [form] = Form.useForm();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [emplacementToDelete, setEmplacementToDelete] = useState(null);
  const [stocks, setStocks] = useState([]);
  const [stocksLoading, setStocksLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [entitys, setEntitys] = useState([]);
  const [entityId, setEntityId] = useState(-1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [bulkModalVisible, setBulkModalVisible] = useState(false);
  const [bulkEntityId, setBulkEntityId] = useState(-1);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [entityFilter, setEntityFilter] = useState("all");

  const fields = [
    { name: "Date de création", field: "createdDate", type: "date" },
    { name: "Titre", field: "title", type: "varchar" },
    { name: "Crée par", field: "createdBy", type: "varchar" },
  ];

  const stocksColumns = [
    {
      name: "Référence",
      selector: "reference",
      sortable: true,
      grow: 1.5,
    },
    {
      name: "Désignation",
      selector: "title",
      sortable: true,
      grow: 2.5,
    },
    {
      name: "Qté",
      selector: "quantity",
      sortable: true,
      grow: 0.5,
      right: true,
    },
    {
      name: "Marque",
      selector: "brandName",
      sortable: true,
      grow: 1,
    },
    {
      name: "Réservé",
      selector: "reserved",
      sortable: true,
      grow: 0.5,
      right: true,
    },
  ];

  const toUpdateData = (values) => {
    setEmplacements(values);
  };

  const filteredEmplacements = emplacements.filter((e) => {
    if (entityFilter === "with") return e.entityId != null;
    if (entityFilter === "without") return e.entityId == null;
    return true;
  });

  const closeCreateModal = () => {
    if (title == "") {
      errorMsg("veuillez remplir tous les champs obligatoires!");
      return;
    }
    toAddOrUpdateEmplacement(title, id, entityId != -1 ? entityId : null).then(
      (res) => {
        successMsg(
          id != -1
            ? "Emplacement mis à jours avec succées!"
            : "Emplacement ajoutée avec succées!"
        );
        toGetDatas();
      }
    );
    setId(-1);
    setCreateModalVisible(false);
    setTitle("");
    setEntityId(-1);
  };

  const columns = [
    {
      name: "Date de création",
      selector: "createdDate",
      sortable: true,
      grow: 1,
      format: (c) => toConvertDate(c.createdDate),
    },
    {
      name: "Catégorie",
      selector: "title",
      sortable: true,
      grow: 2,
    },
    {
      name: "Entité",
      selector: "entityTitle",
      sortable: true,
      grow: 1.5,
      format: (c) => c.entityTitle ?? "-",
    },
    {
      name: "Crée par",
      selector: "createdBy",
      sortable: true,
      grow: 1,
    },
    {
      name: "",
      selector: "id",
      sortable: true,
      format: (emplacement) => (
        <>
          <Button
            onClick={() =>
              toEdit(emplacement.id, emplacement.title, emplacement.entityId)
            }
            icon={<BiPencil />}
          />
          {cookie.load("role") == "Super Admin" && (
            <Button
              onClick={() => toShowDeleteModal(emplacement)}
              icon={<BiTrash />}
              danger
            />
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    toGetDatas();
    toGetEntityList().then((res) => setEntitys(res));
  }, []);
  const toGetDatas = () => {
    toGetEmplacementList().then((res) => {
      setEmplacements(res);
      setEmplacementsAll(res);
      setLoading(false);
    });
  };
  const toShowDeleteModal = (emplacement) => {
    setEmplacementToDelete(emplacement);
    setStocks([]);
    setStocksLoading(true);
    setDeleteModalVisible(true);
    toGetListStocksOfEmplacement(emplacement.id).then((res) => {
      setStocks(res ?? []);
      setStocksLoading(false);
    });
  };

  const toConfirmDelete = () => {
    setDeleteLoading(true);
    toDeleteEmplacement(emplacementToDelete.id)
      .then((res) => {
        successMsg("Emplacement supprimé avec succées!");
        setDeleteLoading(false);
        setDeleteModalVisible(false);
        setEmplacementToDelete(null);
        setStocks([]);
        toGetDatas();
      })
      .catch((e) => {
        setDeleteLoading(false);
        errorMsg("Erreur lors de la suppression de l'emplacement!");
      });
  };

  const toEdit = (id, name, empEntityId) => {
    setId(id);
    setTitle(name);
    setEntityId(empEntityId ?? -1);
    form.setFieldsValue({ name: name });
    setCreateModalVisible(true);
  };
  const toAdd = () => {
    setId(-1);
    setTitle("");
    setEntityId(-1);
    form.setFieldsValue({ name: "" });
    setCreateModalVisible(true);
  };
  const exitCreateModal = () => {
    setId(-1);
    setTitle("");
    setEntityId(-1);

    setCreateModalVisible(false);
  };

  const onSelectRow = (e) => {
    setSelectedRows(e.selectedRows);
  };

  const toOpenBulkModal = () => {
    if (selectedRows.length == 0) {
      errorMsg("Veuillez séléctionner au moins un emplacement!");
      return;
    }
    setBulkEntityId(-1);
    setBulkModalVisible(true);
  };

  const toConfirmBulkUpdate = () => {
    if (bulkEntityId == -1) {
      errorMsg("Veuillez séléctionner une entité!");
      return;
    }
    setBulkLoading(true);
    toUpdateEntityOfEmplacements(
      selectedRows.map((r) => r.id),
      bulkEntityId
    )
      .then((res) => {
        successMsg(
          `${res} emplacement(s) mis à jours avec succées!`
        );
        setBulkLoading(false);
        setBulkModalVisible(false);
        setSelectedRows([]);
        toGetDatas();
      })
      .catch((e) => {
        setBulkLoading(false);
        errorMsg("Erreur lors de la mise à jour de l'entité!");
      });
  };

  return (
    <>
      {props.display && (
        <>
          <Row>
            <Col span="6">
              <Typography.Title level="2">Emplacements</Typography.Title>
            </Col>
            <Col span={"6"}>
              <SearchInput
                list={emplacementsAll}
                fields={["title"]}
                setData={(list) => setEmplacements(list)}
              />
            </Col>
            <Col span="12" style={{ textAlign: "right" }}>
              <Select
                style={{ width: "160px", marginRight: "5px" }}
                value={entityFilter}
                onChange={(v) => setEntityFilter(v)}
              >
                <Select.Option value="all">Tous</Select.Option>
                <Select.Option value="with">Avec entité</Select.Option>
                <Select.Option value="without">Sans entité</Select.Option>
              </Select>
              <Button
                type="primary"
                style={{ marginRight: "5px" }}
                onClick={(e) => setFilterModalVisible(true)}
              >
                Filtrer
              </Button>
              <Button
                style={{ marginRight: "5px" }}
                disabled={selectedRows.length == 0}
                onClick={toOpenBulkModal}
              >
                Changer l'entité ({selectedRows.length})
              </Button>
              <Button
                icon={<PlusOutlined />}
                onClick={(e) => toAdd()}
                type="primary"
              >
                Ajouter un emplacement
              </Button>
            </Col>
          </Row>

          <Row
            style={{
              overflowY: "hidden",
            }}
          >
            <Col span="24">
              <DataTable
                noHeader
                striped
                fixedHeader
                persistTableHead
                selectableRows
                selectableRowsHighlight
                onSelectedRowsChange={(e) => onSelectRow(e)}
                noDataComponent={
                  <span>Pas de bon d'emplacement(s) trouvé(s)</span>
                }
                contextMessage={{
                  singular: "élément",
                  plural: "éléments",
                  message: "séléctionné(s)",
                }}
                columns={columns}
                data={filteredEmplacements}
                pagination
                paginationTotalRows={filteredEmplacements?.length}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
              />
              <Skeleton active loading={loading} />
            </Col>
          </Row>
        </>
      )}

      <Modal
        className="modal-small"
        title={"Filtrer"}
        visible={filterModalVisible}
        footer={[]}
        onCancel={(e) => setFilterModalVisible(false)}
      >
        <Search toUpdateData={toUpdateData} fields={fields} list={emplacementsAll} />
      </Modal>

      <Modal
        title={
          id != -1
            ? "Modifier un emplacement"
            : "Ajouter un nouveau emplacement"
        }
        visible={createModalVisible}
        onOk={closeCreateModal}
        onCancel={exitCreateModal}
      >
        <Form name="basic" form={form}>
          <Form.Item
            label="Nom"
            name="name"
            rules={[{ required: true, message: "Champ obligatoire" }]}
          >
            <Input value={title} onChange={(e) => setTitle(e.target.value)} />
          </Form.Item>
          <Form.Item label="Entité">
            <Select
              style={{ width: "100%" }}
              placeholder="Séléctionner l'entité"
              value={entityId}
              onChange={(e) => setEntityId(e)}
              allowClear
              onClear={() => setEntityId(-1)}
            >
              {entitys.map((e) => (
                <Select.Option key={e.id} value={e.id}>
                  {e.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={`Changer l'entité de ${selectedRows.length} emplacement(s)`}
        visible={bulkModalVisible}
        onOk={toConfirmBulkUpdate}
        onCancel={() => setBulkModalVisible(false)}
        confirmLoading={bulkLoading}
      >
        <Form name="bulk">
          <Form.Item label="Entité">
            <Select
              style={{ width: "100%" }}
              placeholder="Séléctionner l'entité"
              value={bulkEntityId}
              onChange={(e) => setBulkEntityId(e)}
              allowClear
              onClear={() => setBulkEntityId(-1)}
            >
              {entitys.map((e) => (
                <Select.Option key={e.id} value={e.id}>
                  {e.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={`Supprimer l'emplacement ${emplacementToDelete?.title ?? ""}`}
        visible={deleteModalVisible}
        onOk={toConfirmDelete}
        onCancel={() => {
          setDeleteModalVisible(false);
          setEmplacementToDelete(null);
          setStocks([]);
        }}
        okText="Supprimer définitivement"
        cancelText="Annuler"
        okButtonProps={{ danger: true, disabled: stocksLoading }}
        confirmLoading={deleteLoading}
      >
        <Alert
          type="warning"
          showIcon
          message={
            stocksLoading
              ? "Chargement des articles..."
              : stocks.length > 0
              ? `${stocks.length} article(s) avec stock disponible dans cet emplacement. Ils seront supprimés définitivement avec l'emplacement.`
              : "Aucun article avec stock disponible dans cet emplacement. Poursuivre la suppression ?"
          }
          style={{ marginBottom: 16 }}
        />
        <DataTable
          noHeader
          striped
          columns={stocksColumns}
          data={stocks}
          progressPending={stocksLoading}
          pagination={stocks.length > 10}
          paginationRowsPerPageOptions={[10, 20, 50]}
        />
      </Modal>
    </>
  );
};

export default Emplacement;
